import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=78c9f98d&scoped=true&lang=pug"
import script from "./OnboardingModal.vue?vue&type=script&lang=ts"
export * from "./OnboardingModal.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=78c9f98d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9f98d",
  null
  
)

export default component.exports